import { login, logout } from "@apis:auth/auth";
import { getMe, usersQueryKey } from "@apis:user/user";
import { storage } from "@utils:token-storage";
import { configureAuth } from "react-query-auth";
import { CamelCasedPropertiesDeep } from "type-fest";

import { BodyAuthDatabaseLoginAuthJwtLoginPost } from "@:openapi";

export const { useUser, useLogin, useLogout, AuthLoader } = configureAuth({
  userFn: async () => {
    if (storage.getToken()) {
      return await getMe();
    }
    return null;
  },
  userKey: usersQueryKey.me.queryKey,
  // @ts-expect-error -- no need follow the response of original loginFn
  loginFn: async (
    data: CamelCasedPropertiesDeep<BodyAuthDatabaseLoginAuthJwtLoginPost>,
  ) => {
    const response = await login(data);
    const { accessToken } = response;
    if (!accessToken) return;
    storage.setToken(accessToken);
  },
  registerFn: () => Promise.reject("Do nothing"),
  logoutFn: async () => {
    await logout().catch(() => undefined);
    storage.clearToken();
    window.location.assign(window.location.origin as unknown as string);
  },
});
